import Reflux from 'reflux';
import EventData from 'shared/data/Event';
import ItemSetData from 'shared/data/ItemSet';

let async = { asyncResult: true };

let GlobalElementMetricsActions = Reflux.createActions({
  populate: {},
  getEvents: async,
  getProofsOfPerformance: async,
});

GlobalElementMetricsActions.getEvents.listenAndPromise(
  EventData.getByGlobalElement,
);

GlobalElementMetricsActions.getProofsOfPerformance.listenAndPromise(
  ItemSetData.getProofsByGlobalElement,
);

export default GlobalElementMetricsActions;
